import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Container, Spinner, Button, Form, Col, Tabs, Tab } from 'react-bootstrap';
import { Formik, FieldArray } from 'formik';
import * as Yup from "yup";
import { useQuery } from 'react-query';
import api from '../../api';
import { states, cities } from '../../constants/locations';
import DoneSVG from '../../assets/images/undraw_Done_re_oak4.svg';

const scrollToTop = () => window.scrollTo(0, 0);

const Vacancy = () => {
    const [job, setJob] = useState({});
    const [showForm, setShowForm] = useState(false);
    const [cvFile, setCvFile] = useState(null);
    const [isFormFinish, setIsFormFinish] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [tabKey, setTabKey] = useState('vacancy-details');
    const params = useParams();

    useEffect(() => {
        (async () => {
            const res = await api.get(`/jobs/${params.id}`);
            setJob(res.data.data.job);
        })()
    }, [params]);

    const getJobSchema = () => {
        const shape = {
            email: Yup.string().email().required("required"),
            firstName: Yup.string().required("required"),
            middleName: Yup.string(),
            lastName: Yup.string().required("required"),
            age: Yup.string().required("required").max(2, 'Age must contain 2 numbers'),
            cellNumber: Yup.string().required("required").max(10, 'Phone must contain 11 numbers').min(10, 'Phone must contain 11 numbers'),
            gender: Yup.string().required("required"),
            country: Yup.string().required("required"),
            state: Yup.string().required("required"),
            city: Yup.string().required("required"),
            cv: Yup.string().required("required"),
        };

        job.jobtype.questions.map(question => {
            let shapeObject = Yup.string();

            if (question.questionType === 'multiple') {
                shapeObject = Yup.array();
            }

            if (question.isRequired) {
                shapeObject = shapeObject.required('required');
            }

            shape[`question-${question.id}`] = shapeObject;
        });
        console.log('shape: ', shape);
        return Yup.object().shape(shape);
    }

    const getJobInit = () => {
        const values = {
            email: '',
            firstName: '',
            middleName: '',
            lastName: '',
            age: '',
            cellNumber: '',
            gender: '',
            country: '',
            state: '',
            city: '',
            cv: '',
        };

        job.jobtype.questions.map(question => {
            if (question.questionType === 'multiple') {
                values[`question-${question.id}`] = [];
            } else {
                values[`question-${question.id}`] = '';
            }
        });

        return values;
    }

    const handleFormikFileChange = (e, formik) => {
        const file = e.target.files[0];
        formik.handleChange(e);
        setCvFile(file);
    }

    const handleApplicationFormSubmit = (values) => {
        setIsLoading(true);

        const formData = new FormData();

        for (const key in values) {
            if (Array.isArray(values[key])) {
                formData.append(key, JSON.stringify(values[key]));
            } else {
                formData.append(key, values[key]);
            }
        }

        formData.append('cvFile', cvFile);
        formData.append('jobId', params.id);

        api
            .post('/jobs/job/application', formData)
            .then(res => {
                console.log('res: ', res);
                setIsLoading(true);
                scrollToTop();
                setTabKey('vacancy-finish');
            })
            .catch(err => {
                console.log(err);
                setIsLoading(true);
            })
    }

    return (
        <section className="section-vacancy">
            <Container>
                {job.title ? (
                    <Tabs
                        defaultActiveKey={tabKey}
                        transition={false}
                        id="noanim-tab-example"
                        className="mb-3 my-tabs"
                    >
                        <Tab eventKey="vacancy-details" title="" active={tabKey === "vacancy-details" ? true : false}>
                            <div>
                                <h1>{job.title}</h1>
                                <div className="p-4" dangerouslySetInnerHTML={{ __html: job.description }}></div>
                                <Button className="button-ghost" variant="outline-light" onClick={() => setTabKey('vacancy-form')}>Apply Now</Button>
                            </div>
                        </Tab>
                        <Tab eventKey="vacancy-form" title="" active={tabKey === "vacancy-form" ? true : false}>
                            <div>
                                <Formik
                                    onSubmit={handleApplicationFormSubmit}
                                    validationSchema={getJobSchema()}
                                    enableReinitialize
                                    initialValues={getJobInit()}
                                >
                                    {(formik) => (
                                        <Form onSubmit={formik.handleSubmit}>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="firstName" hasValidation>
                                                    <Form.Label className="form__label">First Name</Form.Label>
                                                    <Form.Control
                                                        className="p-3 rounded-0"
                                                        type="text"
                                                        name="firstName"
                                                        placeholder="Enter First Name"
                                                        value={formik.values.firstName}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.firstName && !formik.errors.firstName}
                                                        isInvalid={formik.touched.firstName && formik.errors.firstName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.firstName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="middleName" hasValidation>
                                                    <Form.Label className="form__label">Middle Name</Form.Label>
                                                    <Form.Control
                                                        className="p-3 rounded-0"
                                                        type="text"
                                                        name="middleName"
                                                        placeholder="Enter Middle Name"
                                                        value={formik.values.middleName}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.middleName && !formik.errors.middleName}
                                                        isInvalid={formik.touched.middleName && formik.errors.middleName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.middleName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="lastName" hasValidation>
                                                    <Form.Label className="form__label">Last Name</Form.Label>
                                                    <Form.Control
                                                        className="p-3 rounded-0"
                                                        type="text"
                                                        name="lastName"
                                                        placeholder="Enter Last Name"
                                                        value={formik.values.lastName}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.lastName && !formik.errors.lastName}
                                                        isInvalid={formik.touched.lastName && formik.errors.lastName}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.lastName}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="age" hasValidation>
                                                    <Form.Label className="form__label">Age</Form.Label>
                                                    <Form.Control
                                                        className="p-3 rounded-0"
                                                        type="number"
                                                        name="age"
                                                        placeholder="Enter Age"
                                                        min={1}
                                                        value={formik.values.age}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.age && !formik.errors.age}
                                                        isInvalid={formik.touched.age && formik.errors.age}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.age}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="age" hasValidation>
                                                    <Form.Label className="form__label">Contact Number</Form.Label>
                                                    <Form.Control
                                                        className="p-3 rounded-0"
                                                        type="number"
                                                        name="cellNumber"
                                                        placeholder="03xxxxxxxxx"
                                                        value={formik.values.cellNumber}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.cellNumber && !formik.errors.cellNumber}
                                                        isInvalid={formik.touched.cellNumber && formik.errors.cellNumber}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.cellNumber}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="gender" hasValidation>
                                                    <Form.Label className="form__label">Gender</Form.Label>
                                                    <Form.Control
                                                        className="rounded-0"
                                                        as="select"
                                                        name="gender"
                                                        placeholder="Enter Gender"
                                                        value={formik.values.gender}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.gender && !formik.errors.gender}
                                                        isInvalid={formik.touched.gender && formik.errors.gender}
                                                        custom
                                                    >
                                                        <option value="" disabled>Choose...</option>
                                                        <option value="Male">Male</option>
                                                        <option value="Female">Female</option>
                                                    </Form.Control>
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.gender}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="email" hasValidation>
                                                    <Form.Label className="form__label">Email</Form.Label>
                                                    <Form.Control
                                                        className="p-3 rounded-0"
                                                        type="text"
                                                        name="email"
                                                        placeholder="Enter Email"
                                                        value={formik.values.email}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.email && !formik.errors.email}
                                                        isInvalid={formik.touched.email && formik.errors.email}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.email}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="country" hasValidation>
                                                    <Form.Label className="form__label">Country</Form.Label>
                                                    <Form.Control
                                                        className="p-3 rounded-0"
                                                        type="text"
                                                        name="country"
                                                        placeholder="Enter Country"
                                                        value={formik.values.country}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.country && !formik.errors.country}
                                                        isInvalid={formik.touched.country && formik.errors.country}
                                                    // disabled={true}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.country}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="state" hasValidation>
                                                    <Form.Label className="form__label">State</Form.Label>
                                                    <Form.Control
                                                        className="rounded-0"
                                                        as="select"
                                                        name="state"
                                                        placeholder="Enter state"
                                                        value={formik.values.state}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.state && !formik.errors.state}
                                                        isInvalid={formik.touched.state && formik.errors.state}
                                                        custom
                                                    >
                                                        <option value="" disabled>Choose...</option>
                                                        {states.map(state => (
                                                            <option value={state.key}>{state.name}</option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.state}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group as={Col} controlId="city" hasValidation>
                                                    <Form.Label className="form__label">City</Form.Label>
                                                    <Form.Control
                                                        className="rounded-0"
                                                        as="select"
                                                        name="city"
                                                        placeholder="Enter city"
                                                        value={formik.values.city}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.city && !formik.errors.city}
                                                        isInvalid={formik.touched.city && formik.errors.city}
                                                        custom
                                                    >
                                                        <option value="" disabled>Choose...</option>
                                                        {cities.filter(city => city.state === formik.values.state).map(city => (
                                                            <option value={city.key}>{city.name}</option>
                                                        ))}
                                                    </Form.Control>
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.city}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Form.Row>
                                                {job.jobtype.questions.map(question => (
                                                    <>
                                                        <Form.Group as={Col} md={6} key={question.id} controlId={`question-${question.id}`} hasValidation>
                                                            <Form.Label className="form__label">{question.questionTitle}</Form.Label>
                                                            {question.questionType === "multiple" ? (
                                                                <div className="ml-1">
                                                                    <FieldArray name={`question-${question.id}`} validateOnChange render={() => {
                                                                        return <>
                                                                            {question.questionOptions.map(option => {
                                                                                return (
                                                                                    <Form.Check
                                                                                        inline
                                                                                        label={option}
                                                                                        key={option}
                                                                                        name={`question-${question.id}`}
                                                                                        // type="checkbox"
                                                                                        id={`inline-${option}-1`}
                                                                                        // isInvalid={formik.touched[`question-${question.id}`] && formik.errors[`question-${question.id}`]}
                                                                                        value={option}
                                                                                        onChange={e => { formik.handleChange(e); console.log(formik.values[`question-${question.id}`]) }}
                                                                                        isInvalid={!!formik.errors[`question-${question.id}`]}
                                                                                    // feedback={formik.errors[`question-${question.id}`]}
                                                                                    />
                                                                                )
                                                                            })}
                                                                        </>
                                                                    }}></FieldArray>
                                                                    {/* <Form.Control.Feedback type="invalid">
                                                                        {formik.errors[`question-${question.id}`]}
                                                                    </Form.Control.Feedback>
                                                                    {formik.errors[`question-${question.id}`] ? (
                                                                        <Form.Control.Feedback type="invalid">
                                                                            {formik.errors[`question-${question.id}`]}
                                                                        </Form.Control.Feedback>
                                                                    ) : ('')} */}
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    <Form.Control
                                                                        className={`${question.questionType === "select" ? '' : 'p-3'} rounded-0`}
                                                                        as={question.questionType}
                                                                        type="text"
                                                                        name={`question-${question.id}`}
                                                                        placeholder={question.questionTitle}
                                                                        value={formik.values[`question-${question.id}`]}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        isValid={formik.touched[`question-${question.id}`] && !formik.errors[`question-${question.id}`]}
                                                                        isInvalid={formik.touched[`question-${question.id}`] && formik.errors[`question-${question.id}`]}
                                                                        custom={question.questionType === "select" ? true : false}
                                                                    >
                                                                        {question.questionOptions && question.questionOptions.map((option, index) => {
                                                                            if (index === 0) {
                                                                                return (
                                                                                    <>
                                                                                        <option value="" disabled>Choose...</option>
                                                                                        <option key={option} value={option}>{option}</option>
                                                                                    </>
                                                                                )
                                                                            } else {
                                                                                return (
                                                                                    <option key={option} value={option}>{option}</option>
                                                                                )
                                                                            }
                                                                        })}
                                                                    </Form.Control>
                                                                    {/* <Form.Control.Feedback type="invalid">
                                                                        {formik.errors[`question-${question.id}`]}
                                                                    </Form.Control.Feedback> */}
                                                                </>
                                                            )}
                                                            <Form.Control.Feedback type="invalid">
                                                                {formik.errors[`question-${question.id}`]}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </>
                                                    // <React.Fragment>
                                                    //     </Form.Row>
                                                    //     <Form.Row>
                                                    // </React.Fragment>
                                                ))}


                                            </Form.Row>
                                            <Form.Row>
                                                <Form.Group as={Col} controlId="age" hasValidation>
                                                    <Form.Label className="form__label">Attach CV</Form.Label>
                                                    <Form.Control
                                                        className="rounded-0"
                                                        type="file"
                                                        name="cv"
                                                        placeholder="Enter CV"
                                                        value={formik.values.cv}
                                                        onChange={e => handleFormikFileChange(e, formik)}
                                                        onBlur={formik.handleBlur}
                                                        isValid={formik.touched.cv && !formik.errors.cv}
                                                        isInvalid={formik.touched.cv && formik.errors.cv}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.cv}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Form.Row>
                                            <Button className="button-ghost" variant="outline-light" type="submit">
                                                {/* <Spinner animation="border" size="sm" />
                                                <span>Submit</span> */}

                                                {isLoading ? (
                                                    <Spinner animation="border" size="sm" />
                                                ) : ('')}
                                                <span className={`${isLoading ? 'ml-2' : ''}`}>Submit</span>
                                            </Button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </Tab>
                        <Tab eventKey="vacancy-finish" title="" active={tabKey === "vacancy-finish" ? true : false}>
                            <div>
                                <div dangerouslySetInnerHTML={{ __html: job?.jobResponse }}></div>

                                <div className="d-flex justify-content-center mt-4" style={{ width: '100%' }}>
                                    <img src={DoneSVG} alt="Done" style={{ width: '500px', height: 'auto' }} />
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                ) : (
                    <div className="spinner-container">
                        <Spinner animation="border" />
                    </div>
                )}
                {/* <div className="spinner-container">
                    <Spinner animation="border" />
                </div> */}
            </Container>
        </section>
    )
};

export default Vacancy;